'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.weeksSince;


// WEBPACK FOOTER //
// ./~/sugar-date/date/weeksSince.js